import request from "@/CommonDP/utils/request";
export default {
  //问题专业占比
  problemTypeCount(prjId) {
    return request.get(`/drawing/statistics/problemTypeCount?prjId=${prjId}`)
  },
  //问题复核率占比
  statusCount(prjId) {
    return request.get(`/drawing/statistics/statusCount?prjId=${prjId}`)
  },
  //问题类型占比
  specCount(prjId,fileType) {
    return request.get(`/drawing/statistics/specCount?prjId=${prjId}&fileType=${fileType}`)
  },
  //人数
  getDrawingReviewNum(prjId,enterpriseId) {
    return request.get(`/project/getDrawingReviewNum?prjId=${prjId}&enterpriseId=${enterpriseId}`)
  },
  // 上传项目图片
  projectUpload( formData,prjId,folderId) {
    return request.post(`/doc/upload/${prjId}/${folderId}`,formData)
  },
  // 项目id跟文件id关联
  prjInfoFileIdRela(params) {
    return request.post(`/prjFileRela/add`,params)
  },
  // 根据项目ID获取FileID
  getFileIdList(prjId,source) {
    return request.get(`/prjFileRela/list?prjId=${prjId}&source=${source}`)
  },
  //项目文件删除
  projectfilIdDelete(id) {
    return request.get(`/prjFileRela/delete?id=${id}`)
  },
  //省市获取
  getProvinceCity(params) {
    return request.get(`/dic/content/getByDicContents`,{params})
  },

  //项目立项
  initiationCreatProject(params) {
    return request.post("/project/initiation", params);
  },
  updateProject(params) {
    return request.post("/project/update", params);
  },

   //项目团队
   getprjPersonAll(prjId) {
    return request.get(`/prjPerson/all?prjId=${prjId}`)
  },
   // 导出我的项目
   exportExcel(params) {
    return request({
        responseType: "blob",
        url: "/project/tjcExportExcel",
        method: "post",
        data: {params}
    });
  }
};